import { graphql } from "gatsby"
import * as PropTypes from "prop-types"

import PressIndex from "@components/press/press-index"
import PressReleaseLink from "@components/press-release-link"
import NewsLink from "@components/news-link"
import { Head as BaseHead, paginateTitles } from "@components/Head/Head"

import "../fragments/PressRelease"
import "../fragments/NewsArticle"

const propTypes = {
  data: PropTypes.object.isRequired,
}

const Press = ({ data, pageContext }) => {
  const posts = data.allPressLink.nodes
  const readMoreText = data.readMoreText.content.childMarkdownRemark.internal.content

  const links = posts.map((post) => {
    switch (post.__typename) {
      case "ContentfulPressRelease":
        return <PressReleaseLink post={post} readMoreText={readMoreText} />
      case "ContentfulNewsArticle":
        return <NewsLink post={post} />
      default:
        return <PressReleaseLink post={post} />
    }
  })

  return <PressIndex baseUrl="/press/" pageContext={pageContext} data={data} children={links} />
}

Press.propTypes = propTypes

export default Press

export const query = graphql`
  query ($skip: Int!, $limit: Int!) {
    allPressLink(skip: $skip, limit: $limit, filter: { excludeFromLocale: { ne: true } }, sort: { date: DESC }) {
      nodes {
        __typename
        id
        title
        ... on ContentfulPressRelease {
          slug
          date
        }
        ... on ContentfulNewsArticle {
          author
          date
          url {
            url
          }
        }
      }
    }
    heroText: contentfulText(contentful_id: { eq: "5eSLz73CGzfXolZLblVfJi" }) {
      rtContent {
        raw
      }
    }
    readMoreText: contentfulText(contentful_id: { eq: "3ejAszgt1eCsOoMsu0mqOQ" }) {
      content {
        childMarkdownRemark {
          internal {
            content
          }
        }
      }
    }
    pageMenu: contentfulNavigationMenu(name: { eq: "Press menu" }) {
      id
      link {
        id
        url
        name
      }
    }
    seoMicrocopy: contentfulMicrocopy(contentful_id: { eq: "4Hjl3oMj2vGKOgCuxp4pM2" }) {
      ...microcopy
    }
  }
`

export const Head = (props) => {
  props.data.page = {}
  props.data.page.socialTitle = paginateTitles(props.data.seoMicrocopy.text, props.pageContext.currentPage)
  return <BaseHead {...props} />
}
